import { IntegrationAuthType } from '@aslanpay/portal-common-lib';

import { AuthField } from './types';

export const PROVIDER_OPTIONS = [
  { value: 'WORKDAY', text: 'Workday' },
  { value: 'CEZANNE', text: 'Cezanne' },
];

export const PROTOCOL_OPTIONS = [
  { value: 'REST', text: 'REST' },
  { value: 'SOAP', text: 'SOAP' },
];

export const INTEGRATION_TYPE_OPTIONS = [
  { value: 'HRIS_SYNC', text: 'HRIS Sync' },
  { value: 'TIMESHEET_SYNC', text: 'Timesheet Sync' },
  { value: 'PAYROLL_OUTPUT', text: 'Payroll Output' },
];

export const AUTH_TYPE_OPTIONS = [
  { value: 'NONE', text: 'None' },
  { value: 'API_KEY_HEADER', text: 'API key header' },
  { value: 'BEARER_TOKEN', text: 'Bearer token' },
  { value: 'OAUTH_CLIENT_CREDENTIALS', text: 'OAuth client credentials' },
  { value: 'OAUTH_REFRESH_TOKEN', text: 'OAuth refresh token' },
  { value: 'BASIC', text: 'Basic' },
  { value: 'WS_SECURITY_USERNAME_TOKEN', text: 'WS-Security username token' },
];

// Fields to collect per auth type. Secret fields are rendered as password inputs and are never displayed back.
export const AUTH_FIELDS: Record<IntegrationAuthType, AuthField[]> = {
  NONE: [],
  API_KEY_HEADER: [
    { name: 'headerName', label: 'Header name', secret: false, required: true },
    { name: 'apiKey', label: 'API key', secret: true, required: true },
  ],
  BEARER_TOKEN: [{ name: 'token', label: 'Token', secret: true, required: true }],
  OAUTH_CLIENT_CREDENTIALS: [
    { name: 'tokenUrl', label: 'Token URL', secret: false, required: true },
    { name: 'clientId', label: 'Client ID', secret: false, required: true },
    { name: 'clientSecret', label: 'Client secret', secret: true, required: true },
    { name: 'scope', label: 'Scope', secret: false, required: false },
  ],
  OAUTH_REFRESH_TOKEN: [
    { name: 'tokenUrl', label: 'Token URL', secret: false, required: true },
    { name: 'clientId', label: 'Client ID', secret: false, required: true },
    { name: 'scope', label: 'Scope', secret: false, required: false },
    { name: 'clientSecret', label: 'Client secret', secret: true, required: true },
    { name: 'refreshToken', label: 'Refresh token', secret: true, required: true },
  ],
  BASIC: [
    { name: 'username', label: 'Username', secret: false, required: true },
    { name: 'password', label: 'Password', secret: true, required: true },
  ],
  WS_SECURITY_USERNAME_TOKEN: [
    { name: 'username', label: 'Username', secret: false, required: true },
    { name: 'password', label: 'Password', secret: true, required: true },
  ],
};
